import React from 'react';
import { withRouter, Route, Switch, Redirect, Link } from 'react-router-dom';

import MainPage from '../../containers/MainPage/MainPage';
import About from '../../containers/About/About';
import Schedule from '../../containers/Schedule/Schedule';
import ContactPage from '../../containers/ContactPage/ContactPage';
import Register from '../../containers/Register/Register';
import FeesDeadlines from '../../containers/FeesDeadlines/FeesDeadlines';
import BurgerNav from '../../components/UI/BurgerNav/BurgerNav';
import SideMenu from '../../components/SideMenu/SideMenu';
import Navigation from '../../components/Navigation/Navigation';
import Footer from '../../components/Footer/Footer';
import Backdrop from '../../components/UI/Backdrop/Backdrop';
import Modal from '../../components/UI/Modal/Modal';
import Notice from '../../containers/Notice/Notice';
import Participants from '../../containers/Participants/Participants';
import left_baner from '../../images/cmk2020-main-baner.png';
import Proceedings from '../../containers/Proceedings/Proceedings';
import Exhibition from '../../containers/Exhibition/Exhibition';

import classes from './Layout.module.scss';


const Layout = props => {
    const [displaySideMenu, setDisplaySideMenu] = React.useState(false);
    const [showModal, setShowModal] = React.useState(false);
    const [modalContent, setModalContent] = React.useState({
        title: '',
        body: ''
    })

    const routes = (
        <Switch>
            <Route
                path="/about" component={About} />
            <Route
                path="/participants" ><Participants
                    showModal={setShowModal}
                    setModalContent={setModalContent}
                /></Route>
            <Route
                path="/register"><Register
                    history={props.history}
                    showModal={setShowModal}
                    setModalContent={setModalContent}
                /></Route>
            <Route
                path="/contact" component={ContactPage} />
            <Route
                path="/notice" component={Notice} />
            <Route
                path="/fees-deadlines" component={FeesDeadlines} />
            <Route
                path="/schedule"><Schedule
                    showModal={setShowModal}
                    setModalContent={setModalContent}
                /></Route>
            <Route
                path="/proceedings" component={Proceedings} />
            <Route
                path="/exhibition" component={Exhibition} />
            <Route
                path="/" exact component={MainPage} />
            <Redirect
                to="/" />
        </Switch>
    )

    return <div className={classes.Layout}>
        <Backdrop show={showModal} clicked={() => setShowModal(false)} />
        {showModal && <Modal
            title={modalContent.title}
            fetch={modalContent.fetch}
            content={modalContent.body}
            cancelLabel="Close"
            onModalClose={() => setShowModal(false)} />}
        {displaySideMenu && <SideMenu clicked={() => setDisplaySideMenu(false)} />}
        <div className={classes.Header}>
            <div className={classes.Logo}><Link to="/">CMK2020 Kielce</Link></div>
            <BurgerNav clicked={() => setDisplaySideMenu(true)} />
            <Navigation />
        </div>
        <div className={classes.Content}>
            <div className={classes.Left}>
                <img className={classes.LeftImage} src={left_baner} alt="" />
            </div>
            {routes}
        </div>
        <Footer />
    </div >
}

export default withRouter(Layout);